module.exports = __webpack_public_path__ + "static/media/BPCL_F1.ac84d78e.txt";